
import { Component, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import html2Pdf from "../../lib/html2pdf";
import request from "@/lib/request/request";
import { CompanyConfig } from "@/lib/common/acm";
import ExamResult from "./paper-result-exam.vue";
import Loading from "../../components/loading.vue";
import NR, { NRparam } from "@/lib/model/NRXQ/NRXQ";
import NRLogin from "./components/NRLogin.vue";
import NRInfo from "./components/NRInfo.vue";
import {
  AI,
  Answer,
  Candidate,
  CandidateResult,
  MiddleInfo,
  Param
} from "@/lib/model/exam/result";
import { NRCandidate, NREducation, NRWork } from "@/lib/model/NRXQ/candidate";
import { NRClientType } from "@/lib/model/NRXQ/nr";
import AtsCV from "./components/cv.vue";
import AtsCVH5 from "./components/cv-h5.vue";
import { FingerCheckResult } from "@/lib/model/exam/result";
import EchartsDisc from "./components/echarts-disc.vue";
import { Permission } from "@/lib/model/common";
import TemplateBlank from "@/components/templateBlank.vue";
import Log from "@/lib/log/log";
import SingleDimensionMindRes from "@/components/single-dimension-mind-res.vue";
import Login from "@/views/paper/paper-result-report/login.vue"; //提取码登录
import { Report } from "@/lib/model/exam/candidate";
import { replaceBgCheckString } from "@/utils/common";

//背调状态
enum bgStatus {
  "-",
  "未通过身份验证无法查询" = 1,
  "通过" = 2,
  "不通过-查询到异常记录" = 3,
  "验证中" = 4,
  "未知原因无法查询" = 5,
  "未通过身份验证无法查询 " = 102
}
// 风险等级
enum levelOfBg {
  "",
  "存在低风险",
  "存在中风险",
  "存在高风险",
  "存在异常风险"
}
//异常项
enum errorEnum {
  "screenshot" = "截屏检测",
  "mobileJoinCount" = "切屏检测",
  "replacePerson" = "换人检测",
  "readCheating" = "念稿检测",
  "faceCheck" = "身份认证",
  "finger" = "手部综合检测",
  "webJump" = "Web防切屏检测",
  "eyeColor" = "辨色检测",
  "faceDetection" = "露脸检测"
  // "bgCheck" = "背调结果",
  // "bgCheckSocial" = "社会安全风险",
  // "bgCheckFinancial" = "金融风险",
  // "bgCheckIdentity" = "手机号实名认证"
}
enum levelToRisk {
  "旧数据",
  "存在低风险",
  "存在中风险",
  "存在高风险",
  "存在异常风险"
}
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}
export class EmotionData {
  emotionType = "";
  imgUrl = "";
}

@Component({
  components: {
    TemplateBlank,
    ExamResult,
    Loading,
    NRInfo,
    NRLogin,
    AtsCV,
    AtsCVH5,
    EchartsDisc,
    SingleDimensionMindRes,
    Login
  }
})
export default class PaperResult extends Vue {
  $refs!: {
    echartsL: HTMLCanvasElement;
    echartsR: HTMLCanvasElement;
    echartTop: HTMLCanvasElement;
    echartTopExam: HTMLCanvasElement;
    echartTopMobile: HTMLCanvasElement;
    echartsLMobile: HTMLCanvasElement;
    result: HTMLFormElement;
    atsCv: HTMLFormElement;
    atsCvH5: HTMLFormElement;
    lockH: HTMLElement;
    lockHH5: HTMLElement;
    PCvideo: HTMLElement[];
    foot: HTMLElement;
  };
  //饼图用色
  colorList = [
    "#4CDE99",
    "#FDC151",
    "#33DFE4",
    "#8851FD",
    "#33B1FF",
    "#FF9245",
    "#FD5151",
    "#BDFD51",
    "#516AFD",
    "#B999D4",
    "#51FD84",
    "#FD51B8",
    "#FDFB51",
    "#51FDC5",
    "#E551FD"
    // "#FF7717",
    // "#009EFF",
    // "#A87FC9",
    // "#FDB225",
    // "#00D7DD",
    // "#00D16E"
  ];
  opacity = "red";
  //成绩
  infoList: any[] = [];
  //AI维度
  AIList: any[] = [];
  scoreTotal = 0; //总分
  scoreTotalAll = 0; //满分
  AIMessageList: any[] = [];
  all = new CandidateResult();
  isEnableAi = false;
  dataReady = false; //数据加载完成
  isPc = false; //是否pc访问
  isC = false; // 候选人端
  bgList: any[] = []; //背调信息
  // emotionDataList: EmotionData[] = []; //神态截图
  // psychiatricExaminationAi = 0;
  // psychiatricExaminationHr = 0;
  //Ec雷达配置
  optionRadar = {
    tooltip: {},
    legend: {
      left: "right",
      top: "bottom",
      orient: "vertical", //排列方向 horizontal
      textStyle: {
        color: "#8590A6",
        fontSize: 9
      },
      itemHeight: 10,
      itemWidth: 10,
      data: ["维度得分", "维度中位分"]
    },
    radar: {
      shape: "circle",
      splitNumber: 5, //几段线
      nameGap: 5, //名称和轴的距离
      radius: "65%",
      splitArea: { areaStyle: { color: ["#FFFFFF"] } }, //背景区域
      splitLine: { lineStyle: { color: ["#EAEDF7"] } }, //极坐标
      axisLine: { lineStyle: { color: "#EAEDF7" } }, //轴线
      name: {
        textStyle: {
          fontSize: "9",
          fontWeight: 400,
          fontFamily: "PingFangSC-Regular",
          color: "#8590A6"
        }
      },
      indicator: [
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 }
      ]
    },
    series: [
      {
        name: "考察维度得分",
        type: "radar",
        symbol: "circle", //形状
        symbolSize: 2, // 拐点的大小
        itemStyle: {
          color: "#FF5FA6FF"
        },
        data: [
          {
            value: [0],
            name: ""
          }
        ],
        lineStyle: { color: "#FF5FA6FF", width: 1 },
        areaStyle: { color: "#FF5FA626", opacity: 0.15 }
      }
    ]
  };
  //Ec饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: "{b}：{d}%"
    },
    series: [
      {
        name: "考察维度权重",
        type: "pie",
        clockwise: false, //是否顺时针
        color: this.colorList,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 9,
          lineHeight: 12,
          color: "#8590A6",
          formatter: "{b}" + "\n" + "{d}%",
          position: "left"
        },
        itemStyle: { borderWidth: 1, borderColor: "#FFFFFF" },
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "9px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 10, //两段线 控制文字位置
          length2: 0
        },
        data: [
          { value: 200, name: "A权重占比" },
          { value: 400, name: "B权重占比" },
          { value: 100, name: "C权重占比" },
          { value: 484, name: "D权重占比" },
          { value: 300, name: "E权重占比" },
          { value: 300, name: "F权重占比" }
        ]
      }
    ]
  };
  //Ec时速表配置
  optionGauge = {
    series: [
      {
        radius: "100%",
        type: "gauge",
        max: 160,
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            color: "red"
          }
        },
        axisLine: {
          lineStyle: {
            width: 5
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          distance: 50
        },
        data: [
          {
            value: 80,
            name: "得分",
            title: {
              offsetCenter: ["0%", "30%"]
            },
            detail: {
              offsetCenter: ["0%", "-20%"]
            }
          }
        ],
        title: {
          fontSize: 8 //12
        },
        detail: {
          width: 50,
          height: 14,
          fontSize: 16, //24,
          color: "red",
          formatter: "{value}"
        }
      }
    ]
  };
  showBigImg = false;
  bigImgUrl = "";
  candidate = new Candidate(); //候选人信息 主表
  candidateResult = new CandidateResult(); //候选人信息 所有表
  connectCode = "";
  middleInfo = new MiddleInfo();
  showMS = false; //展示中位数数据
  mindData = new Answer();
  examData: any = {}; //笔面试报告数据
  pdfIng = false; //下载pdf中
  showCopyToast = false; // 复制报告链接提示
  timer = 0;
  count = 0;
  isNRXQ = false; //是否牛人星球
  showNRLogin = false;
  showNRInfo = false;
  showShare = false; //展示分享按钮
  showShareH5 = false;
  nrxqToken = "";
  atsCvOutId = ""; //ats展示简历内容
  clientType = NRClientType.NRClientTypeCandidate;
  cv = new NRCandidate();
  isNrLock = true; //牛星 报告页未登录（锁上只能看局部）
  nrNeedTo = ""; //记录牛星 去登录or去填信息
  showLock = false; //展示锁定区域 / banner
  userColse = false; //用户关闭banner
  fixedFoot = true; //悬浮脚
  judgeOutId = "";
  passwd = "";
  showRefAnswer = false; //展示参考答案；
  audioElement: any = null;
  maxAdvantageArrayLength = 5; //优缺点最长展示几条
  openAiComment = 0; // 展示AI评价
  timerOpenedTracking = 0;

  replaceBgCheckString = replaceBgCheckString;

  get resLogo() {
    const companyConfig = CompanyConfig.getInstance(this.all.exam.companyId);
    const t = Number(this.candidate.auditStatus); //结果logo
    const sft = this.candidate.aiRecommendStatus;
    if (companyConfig.resultLogoType == 1 && ![20, 0].includes(sft)) {
      //顺丰结果logo 判ai推荐 如果是待评估 则判下面的常规
      return require("../../assets/exam/" +
        (sft === 40 ? "r4" : sft === 30 ? "r1" : sft === 10 ? "r3" : "r0") +
        "sf" +
        ".png");
    } else {
      //常规  三种结果logo
      return require("../../assets/exam/" +
        (t === 1 ? "r1" : t === 2 ? "r2" : t === 3 ? "r3" : "r0") +
        (companyConfig.resultLogoType == 1 ? "sf" : "") +
        ".png");
    }
  }
  get styleVar() {
    return this.isNrLock ? "height:100vh;overflow:hidden" : "no";
  }
  //是否隐藏手机号
  get isHidePhone() {
    return CompanyConfig.getInstance().isHidePhone === 1;
  }
  //是否展示简历链接
  get isShowAttachment() {
    return CompanyConfig.getInstance().isShowAttachment === 1;
  }
  //是否隐藏AI推荐
  get isHideResultAiStar() {
    return CompanyConfig.getInstance().isHideResultAiStar === 1;
  }
  //hr修改小维度
  get showHrChange() {
    return this.all.dimensionReport.find((d: AI) => {
      return d.afterHrChange === 1;
    });
  }
  //查看大图
  openImg(url: string) {
    this.bigImgUrl = url;
    this.showBigImg = true;
  }
  //打气球游戏数据
  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //西蒙斯游戏数据
  get gameXi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 2;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  // 微信浏览器判断
  get isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/micromessenger/) != null;
  }

  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }
  get fingerAnswer() {
    return this.all?.questionAnswerMap?.[109]?.[0]?.answer || new Answer();
  }
  fingerResText(i: number) {
    return enumFinger[i];
  }

  //AI推荐级别
  get AiStar() {
    const star = this.candidate.aiRecommendStatus;
    const text =
      star === 10
        ? "不推荐"
        : star === 20
        ? "一般"
        : star === 30
        ? "推荐"
        : star === 40
        ? "非常推荐"
        : "无";
    return {
      text: text,
      level: star
    };
  }
  //显示分享按钮   &&牛星客户端 不展示分享按钮
  get ifShare() {
    return (
      this.candidate.shareHost && !document.location.origin.includes("nrpla")
    );
  }
  get isSF() {
    return this?.all?.exam?.companyId === 80925;
  }
  get isDing() {
    return (
      navigator.userAgent.includes("DingTalk") ||
      navigator.userAgent.includes("dingtalk")
    );
  }
  //钉钉h5返回
  back() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.close();
    }
  }
  //其他权限  list以外的都算
  otherPowerList = [
    "姓名",
    "姓名/手机",
    "手机",
    "邮箱",
    "身份证号",
    "新建时间",
    "面试状态",
    "通知状态",
    "提交时间",
    "交卷方式",
    "负责人",
    "身份证号",
    "身份证",
    "身份证号后6位",
    "AI打分",
    "AI推荐",
    "评估结果",
    "得分",
    "面试官评分",
    "AI评估说明",
    "面试官结果"
  ];
  get paramListFilterByPower() {
    const res = this.candidate.paramList.filter(d => {
      return (
        !(
          !this.$P.candidateInfo.other && !this.otherPowerList.includes(d.name)
        ) &&
        ![
          this.connectCode,
          this.candidate.showName,
          this.candidate.phone
        ].includes(d.value)
      );
    });
    return res;
  }

  async created() {
    console.log(document.location.origin);
    document.title = document.location.origin.includes("mianshi.nrpla")
      ? "牛人星球"
      : "海纳AI面试";
    await Permission.getPerm(); //拉下用户权限（非需登录页面，没有头所以独立拉一下）
  }
  tid = "";
  // 缓存提取码对应的面试id
  reportCertiCodeCacheExamId = 0;
  // 是否需要提取码
  async needPassword(retryCount = 0): Promise<boolean | undefined> {
    try {
      const res = await Report.getInfo({
        connectCode: this.connectCode,
        tid: this.$route.query.tid as string
      });
      this.reportCertiCodeCacheExamId = res.reportCertiCodeCacheExamId;
      return res.needReportCertiCode;
    } catch (e) {
      console.error(e);
      // 可以根据重试次数决定是否再次调用
      if (retryCount < 3) {
        // 假设最多重试3次
        return this.needPassword(retryCount + 1);
      } else {
        // 达到最大重试次数后
        this.$message.error("网络不佳，请稍后重试吧");
      }
    }
  }

  showLogin = false;
  login() {
    this.showLogin = false;
    this.loadPage();
  }

  async checkPwd() {
    const needPwd = await this.needPassword(); //此处不封try catch，网络不通就需要停在这里
    if (needPwd) {
      //先判缓存的提取码是否正确
      const pass = await (this.$refs as any).login.checkLocalstroage();
      //不正确则展示提取码页面
      if (!pass) {
        this.showLogin = true;
      }
      return pass;
    }
    return true; //不需要提取码
  }

  async mounted() {
    this.judgeOutId = (this.$route.query?.judgeOutId as string) || "";
    this.passwd = (this.$route.query?.passwd as string) || "";
    this.connectCode = this.$route.query.connectCode as string;
    this.atsCvOutId = (this.$route.query?.atsCvOutId as string) || ""; //有 则是 带简历版报告页（牛星）
    this.isPc = !this.isMobile();
    this.isC = Boolean(this.$route.query?.noUD);
    this.showRefAnswer =
      !this.isSF &&
      (Boolean(this.$route.query?.showReferenceAnswer) || !this.isC);
    this.maxAdvantageArrayLength = Number(this.$route.query?.maxP) || 5; // 优缺点最长展示几条
    //是否需要输入提取码
    const pass = await this.checkPwd();
    if (!pass) return;
    this.loadPage();
  }
  async loadPage() {
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    //是否解锁全部内容（现在是banner模式）起源于牛星
    if (await this.NRXQisError()) {
      return;
    }
    //加载报告
    this.open();
  }
  //埋点事件-查看报告
  trackOpened() {
    const url = document?.location?.href;
    this.timerOpenedTracking = setTimeout(() => {
      Log.sendLog({ type: "reportOpenedTimeBySF", data: { reportUrl: url } });
    }, 5000);

    // document.addEventListener("visibilitychange", () => {
    //   if (document.visibilityState === "visible") {
    //     clearTimeout(this.timerOpenedTracking);
    //     console.log("正在看我" + new Date());
    //   } else {
    //     console.log("不看我了" + new Date());
    //   }
    // });
  }

  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }
  //牛人星球 前置步骤 判断下一步去向
  //****目前迭代为都可以直接看 区别是是否展示banner引导登录***
  async NRXQisError() {
    const P = new NRparam();
    P.connectCode = this.connectCode;
    P.atsUserToken = String(localStorage.getItem("nrToken") || "");
    try {
      P.nrxqToken = String(localStorage.getItem("nrxqToken") || "");
    } catch {
      P.nrxqToken = this.nrxqToken;
    }
    return await NR.checkToken(P).then(resp => {
      const res = resp.nrxqLoginStatus;
      //需登陆
      if (res === "needLogin") {
        this.isNrLock = true;
        // this.toNRLogin();
        this.nrNeedTo = res;
        return false; //true
      }
      //需登记信息
      if (res === "needContent") {
        this.isNrLock = true;
        // this.toNRInfo();
        this.nrNeedTo = res;
        return false; //true
      }
      //直接看
      if (res === "noNeed") {
        // this.isNrLock = true; //test
        this.isNrLock = false;
        return false;
      }
    });
  }
  toWhich() {
    if (this.nrNeedTo === "needLogin") {
      this.toNRLogin();
    }
    if (this.nrNeedTo === "needContent") {
      this.toNRInfo();
    }
  }
  //登录
  toNRLogin() {
    this.showNRLogin = true;
    this.showNRInfo = false;
  }
  //登记信息
  toNRInfo(token = "") {
    if (token) this.nrxqToken = token;
    this.showNRLogin = false;
    this.showNRInfo = true;
  }
  //从 登录后或登记后 打开报告
  toOpen(token = "") {
    if (token) this.nrxqToken = token;
    this.showNRLogin = false;
    this.showNRInfo = false;
    this.isNrLock = false;
    this.open();
  }
  //锁定内容高度
  setTopHeight(height: number) {
    // const dom = document.getElementById("full");
    // // height += 220; //多漏一点
    // dom?.style?.setProperty("--lock-height", height + "px");
    // console.log(height + "px");
    this.showLock = this.isNrLock ? true : false;
  }

  //加载报告 入口
  async open() {
    let token = "";
    try {
      token = String(localStorage.getItem("nrxqToken"));
    } catch (e) {
      console.log(e);
    }

    //确保Ec容器渲染完成
    this.$nextTick(async () => {
      //主表
      Candidate.get({
        connectCode: this.connectCode,
        nrxqToken: token || this.nrxqToken,
        atsUserToken: String(localStorage.getItem("nrToken") || ""),
        judgeOutId: this.judgeOutId,
        passwd: this.passwd,
        tid: this.tid
      })
        .then(res => {
          res.paramList = res.paramList.filter(d => {
            return (
              d.isShow === 1 &&
              (!this.isHidePhone || (this.isHidePhone && d.name !== "手机"))
            );
          });
          this.candidate = res;
          if (this.candidate?.bgCheckResult?.product?.productId !== 0) {
            //购买背调
            this.getBG();
          }
          return CandidateResult.get({
            connectCode: this.connectCode,
            judgeOutId: this.judgeOutId,
            passwd: this.passwd,
            tid: this.tid
          }); //所有表
        })
        .then(r => {
          this.all = r;
          this.openAiComment = this.all.exam.openAiComment;
          //笔面试数据
          this.examData = r.coderDetail || undefined;
          this.showMS =
            CompanyConfig.getInstance(this.all.exam.companyId)
              .showMiddleScore === 1;
          //如果有维度中位数
          if (this.showMS) {
            CandidateResult.getMiddle({ connectCode: this.connectCode }).then(
              middleRes => {
                this.middleInfo = middleRes;
                this.setEcharts(r.dimensionReport); //EC
                this.setScore(r.candidateReport); //得分
              }
            );
          } else {
            this.setEcharts(r.dimensionReport); //EC
            this.setScore(r.candidateReport); //得分
          }
          this.AIMessageList = r.dimensionReportMessage;
          this.isEnableAi = this.all.exam.companySpecialConfig.isEnableAi == 1;
          this.showColorRes(); //色盲结果
          this.sortInfo(); //个人信息 排序
          this.setMindData(); //标准心理测试结果
          this.setScoreEc();
          //隐藏重复身份证
          if (this.all.livenessRecognitionResult.isAssigned) {
            this.candidate.paramList = this.candidate.paramList.filter(d => {
              return d.inputType !== "idcard";
            });
          }
          this.$nextTick(() => {
            this.listenVideo(); //视频监听
            //客户引用页面要的高度
            this.sendHeight();
          });
          this.setCompanyLink();
          if (this.isSF) {
            this.trackOpened();
          }
        })
        .finally(() => {
          if (this.$route.query.autoDownload === "1") {
            setTimeout(() => {
              this.down();
            }, 2000);
          }
        });
      if (this.atsCvOutId) {
        this.cv = await NRCandidate.get(this.atsCvOutId, this.clientType);
        console.log(this.cv);
      }
      this.setScroll();
    });
  }
  // AI评价
  get aiComment() {
    if (this.all && this.all.aiComment && this.all.aiComment.aiComment)
      return this.all.aiComment.aiComment;
    else return "";
  }
  get aiCommentAdvantage() {
    if (this.all && this.all.aiComment)
      return this.all.aiComment.advantageArray.slice(
        0,
        this.maxAdvantageArrayLength
      );
    else return [];
  }
  get aiCommentDisadvantage() {
    if (this.all && this.all.aiComment)
      return this.all.aiComment.disadvantageArray.slice(
        0,
        this.maxAdvantageArrayLength
      );
    else return [];
  }
  //成绩时速表
  setScoreEc() {
    if (this.atsCvOutId) return; //简历版不需要作图
    if (this.examData) {
      this.getExamScore();
    }
    this.optionGauge.series[0].max = this.all.candidateReport.scoreExam;
    this.optionGauge.series[0].data[0].value = this.candidate.score;
    this.optionGauge.series[0].data[0].name = this.examData
      ? "面试得分"
      : "得分";
    if (this.isPc) {
      this.optionGauge.series[0].title.fontSize = 12;
      this.optionGauge.series[0].detail.fontSize = 24;
    }
    const echartTop = this.isPc
      ? echarts.init(this.$refs.echartTop)
      : echarts.init(this.$refs.echartTopMobile);
    echartTop.setOption(this.optionGauge);
  }
  //笔面试的成绩时速表
  getExamScore() {
    if (this.atsCvOutId) return; //简历版不需要作图
    const option = JSON.parse(JSON.stringify(this.optionGauge));
    option.series[0].max = this.all.coderDetail.paperScore;
    option.series[0].data[0].value = this.all.coderDetail.score;
    option.series[0].data[0].name = "笔试得分";
    option.series[0].title.fontSize = 12;
    option.series[0].detail.fontSize = 24;
    const echartTop = echarts.init(this.$refs.echartTopExam);
    echartTop.setOption(option);
  }
  //个人信息 根据文字长度整理
  sortInfo() {
    const arrL: any[] = []; //长选项
    const arrS: any[] = []; //短选项
    this.candidate?.paramList.forEach((d: Param) => {
      if (
        d?.name.length > 21 ||
        (d.inputType !== "file" && d?.cascadeValue.length > 18)
      ) {
        d.long = true;
        arrL.push(d);
      } else {
        arrS.push(d);
      }
    });
    this.candidate.paramList = [...arrS, ...arrL];
  }
  //处理色盲测试结果
  showColorRes() {
    //顺丰旧版色盲题
    this.all.answerList.forEach((d: Answer) => {
      if ([2956, 13689].includes(d.questionId)) {
        const t = new Param();
        t.name = "色盲检测";
        t.cascadeValue =
          d.blanksIsRight.find(res => res === false) !== undefined
            ? "不通过"
            : "通过";
        this.candidate.paramList.push(t);
      }
    });
    //新版色盲题 -> 挪到个人成绩里
    // this.all.answerList.forEach((d: Answer) => {
    //   if (d.type === 102) {
    //     const t = new Param();
    //     t.name = "色盲检测";
    //     t.cascadeValue = d.testResult === 1 ? "通过" : "不通过";
    //     this.candidate.paramList.push(t);
    //   }
    // });
    this.showLock = this.isNrLock ? true : false; //展示banner
    this.dataReady = true;
    //计算露出高度
    this.$nextTick(() => {
      //原来 从子组件计算
      // if (this.isPc) {
      //   this.$refs.atsCv?.getH();
      // } else {
      //   this.$refs.atsCvH5?.getH();
      // }
      //从题目底部算
      // setTimeout(() => {
      //   const dom = this.isPc ? this.$refs.lockH : this.$refs.lockHH5;
      //   if (dom?.offsetTop) {
      //     this.setTopHeight(dom?.offsetTop - 200);
      //   }
      // }, 1000);
    });
  }

  //处理成绩
  setScore(r: any) {
    this.infoList = [
      { name: "得分", value: `${r.score}/${r.scoreExam}` },
      {
        name: "用时",
        value: `${Math.floor(r.useTimeSecond / 60)}分${Math.round(
          r.useTimeSecond % 60
        )}秒`
      },

      { name: "开始面试时间", value: r.beginTime },
      { name: "完成面试时间", value: r.submitTime }
    ];
    //已交卷
    if (this.candidate.submitStatus === 2) {
      this.infoList.push({
        name: "完成面试方式",
        value: this.candidate.submitType
      });
    }

    //截屏检测
    if (this.all.errorInfoList.length) {
      this.all.errorInfoList.forEach((d: any) => {
        if (!errorEnum[d.task]) return;
        this.infoList.push({
          name: errorEnum[d.task],
          value:
            d.result === 2
              ? "正常"
              : d.result === 1
              ? this.getShowMessage(d) //"异常"
              : "信息不足，未完成检测"
        });
      });
    }
    //手部检测
    if (this.finger._isAssignedFlag) {
      //resultFlexible
      this.infoList.push({
        name: "手指灵活度",
        value:
          this.fingerAnswer.isAnswered !== 1
            ? "未完成提交"
            : this.finger.resultFlexible === 1
            ? "通过"
            : "未通过"
      });
      this.infoList.push({
        name: "手指完整度",
        value:
          this.fingerAnswer.isAnswered !== 1
            ? "未完成提交"
            : this.finger.resultComplete === 1
            ? "通过"
            : "未通过"
      });
      this.infoList.push({
        name: "手部疤痕纹身",
        value:
          this.fingerAnswer.isAnswered !== 1
            ? "未完成提交"
            : this.finger.resultScar === 1
            ? "通过"
            : "未通过"
      });
    }
    //通用色盲结果
    this.all.answerList.forEach((d: Answer) => {
      if (d.type === 102) {
        this.infoList.push({
          name: "辨色检测",
          value: d.testResult === 1 ? "通过" : "未通过"
        });
      }
    });

    if (this.showMS) {
      const n = this.middleInfo.candidateIndex;
      const m = this.middleInfo.candidateCount;
      let percent = 0;
      if (m > 1) {
        percent = Math.round(((m - n) / (m - 1)) * 100);
      }
      this.infoList.splice(2, 0, {
        name: "本场面试排名",
        value: `${n}/${m} ${m > 1 ? `（超过${percent}%的候选人）` : ``}`
      });
    }
  }
  getShowMessage(d: any) {
    // 社会金融异常提示
    console.log(this.candidate, "this.candidate");
    const {
      financialRiskStatus,
      financialRiskErrorLevel,
      socialInfoStatus,
      socialInfoErrorLevel
    } = this.candidate.bgCheckResult;
    let result = "异常";
    if (
      financialRiskStatus === 3 &&
      financialRiskErrorLevel &&
      financialRiskErrorLevel > 0 &&
      d.task === "bgCheckFinancial"
    ) {
      result = `不通过-${levelToRisk[financialRiskErrorLevel]}`;
    }
    if (
      socialInfoStatus === 3 &&
      socialInfoErrorLevel &&
      socialInfoErrorLevel > 0 &&
      d.task === "bgCheckSocial"
    ) {
      result = `不通过-${levelToRisk[socialInfoErrorLevel]}`;
    }
    return result;
  }
  //Ec渲染
  setEcharts(r: any) {
    if (this.atsCvOutId) return;
    if (r.length === 0) return;
    this.scoreTotal = 0;
    this.scoreTotalAll = 0;
    this.optionRadar.series[0].data[0].value = [];
    this.optionRadar.radar.indicator = [];
    this.optionPie.series[0].data = [];
    const middleScoreList: number[] = [];
    r.forEach((d: any, index: number) => {
      this.scoreTotal += d.score; // 总得分
      this.scoreTotalAll += d.scoreAll; //总分
      this.optionRadar.radar.indicator.push({
        name: d.dimension,
        max: d.scoreAll
      });
      this.optionRadar.series[0].data[0].value.push(d.score > 0 ? d.score : 0); //雷达数据
      const m =
        this.middleInfo.dimensionReportNew?.[index]?.medianScore < 0
          ? 0
          : this.middleInfo.dimensionReportNew?.[index]?.medianScore;
      middleScoreList.push(m); //中位数
      this.optionPie.series[0].data.push({
        name: d.dimension,
        value: d.scoreAll
      }); //饼图数据
    });
    //中位数展示
    if (this.showMS) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.optionRadar.series.push({
        name: "考察维度中位分",
        type: "radar",
        symbol: "circle", //形状
        symbolSize: 1, // 拐点的大小
        itemStyle: {
          color: "#525FFFFF"
        },
        data: [
          {
            value: middleScoreList,
            name: "维度中位分"
          }
        ],
        lineStyle: { color: "#525FFFFF", width: 1 },
        areaStyle: { color: "#525FFF0D", opacity: 0.15 }
      });
      this.optionRadar.series[0].data[0].name = "维度得分";
      this.optionRadar.tooltip = {
        appendToBody: true, //起到提前渲染作用 防止float计算距离时会错位
        formatter(params: any) {
          let t = params.seriesName + `<br/>`;
          params.value.forEach((d: any, i: number) => {
            t +=
              `<span style="display:inline-block;margin:0 8px 3px 3px;border-radius:4px;width:4px;height:4px;background-color:${params.color};"></span>` +
              r[i].dimension +
              `：<span style="float:right">`;
            t +=
              params.seriesName === "考察维度中位分"
                ? that.middleInfo.dimensionReportNew[i].medianScore +
                  `</span><br/>`
                : r[i].score +
                  ` (中位分${that.middleInfo.dimensionReportNew[i].medianScore})</span><br/>`;
          });
          return t;
        }
      };
    }

    //AI表格
    this.AIList = r || [];
    this.$nextTick(() => {
      const echartsL = this.isPc
        ? echarts.init(this.$refs.echartsL)
        : echarts.init(this.$refs.echartsLMobile);
      //雷达
      echartsL.setOption(this.optionRadar);
      //饼图
      const echartsR = echarts.init(this.$refs.echartsR);
      echartsR.setOption(this.optionPie);
    });
  }
  close() {
    //
  }
  //标准心理结果
  setMindData() {
    this.mindData =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer ?? new Answer();
  }
  //背调结果
  getBG() {
    const b = this.candidate.bgCheckResult;
    if (![0, 255].includes(b.identityInfoStatus)) {
      this.bgList.push({
        title: "手机号实名认证",
        text: b.identityInfoStatus === 2 ? "通过" : "未通过"
      });
    }
    if (![0, 255].includes(b.socialInfoStatus)) {
      this.bgList.push({
        title: "综合A类评估",
        text:
          b.socialInfoErrorLevel && b.socialInfoStatus === 3
            ? levelOfBg[b.socialInfoErrorLevel]
            : bgStatus[b.socialInfoStatus]
      });
    }
    if (![0, 255].includes(b.financialRiskStatus)) {
      this.bgList.push({
        title: "综合B类评估",
        text:
          b.financialRiskErrorLevel && b.financialRiskStatus === 3
            ? levelOfBg[b.financialRiskErrorLevel]
            : bgStatus[b.financialRiskStatus]
      });
    }
  }
  //维度占比
  getScoreAllResult(score: number, scoreAll: number) {
    const res = (score * 100) / scoreAll;
    return (Number.isInteger(res) ? res : res.toFixed(2)) + "%";
  }

  getDimensionDesc(item: any) {
    // if (item.reportDescription) return item.reportDescription;
    // else
    return this.getMark(item);
  }
  getMark(item: any) {
    const percent = Math.round((item.score / item.scoreAll) * 100);
    let judge = "较差";
    if (percent >= 60 && percent < 80) {
      judge = "中等";
    } else if (percent >= 80) {
      judge = "良好";
    }
    return judge;
  }
  //下载pdf
  down() {
    this.pdfIng = true;
    this.$nextTick(() => {
      const downloadBtn: HTMLElement = document.getElementById(
        "download"
      ) as HTMLElement;
      const resultBox: HTMLElement = document.getElementById(
        "mainBox"
      ) as HTMLElement;
      if (downloadBtn) downloadBtn.style.visibility = "hidden";
      html2Pdf.downloadPDF(
        resultBox,
        "面试报告-" + this.candidate.showName,
        false,
        [],
        this.$route.query.autoDownload === "1"
      );
      if (downloadBtn) downloadBtn.style.visibility = "visible";
      this.pdfIng = false;
    });
  }
  //头像占位
  defImg(event: any) {
    this.candidate.photoUrl = "";
    const img = event.srcElement;
    // img.src = require("../../assets/head-logo-long.png");
    img.onerror = null; //防止闪图
  }
  //标签样式
  getColor(i: number) {
    return i === 1 ? "good" : i === 4 ? "mid" : i === 3 ? "sup" : "";
  }
  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }
  //填空题答案
  blankAnswer(answer: any) {
    let t = ``;
    answer.blanks.forEach((d: any, i: number) => {
      t += `${i + 1}.（${d}）    `;
    });
    return t;
  }
  //拼接通勤时间 候选人回答
  getLocationText(answer: any, question: any) {
    const t = answer?.locationQuestionAnswer;
    //未作答
    if (!t) return;
    //正常作答
    if (answer?.keys?.[0]) {
      return `我住在<b>${
        t.locationName
      }</b>附近，经系统计算从该地点到上班地点：驾车距离<b>${(
        t.distanceDriving / 1000
      ).toFixed(1)}公里</b>，用时<b>${
        t.timeDriving
      }分钟</b>，乘坐公共交通距离<b>${(t.distanceTransit / 1000).toFixed(
        1
      )}公里</b>，用时<b>${t.timeTransit}分钟</b>。`;
    } else {
      //定位故障
      if (t.locationName) {
        return `我住在${t.locationName}附近`;
      }
      //暂无居所
      if (t.choiceQuestionAnswer) {
        const res: any[] = question.locationQuestionConfig.choiceQuestionList.filter(
          (d: any) => {
            return d.key === t.choiceQuestionAnswer;
          }
        );
        return res?.[0]?.desc;
      }
    }
  }
  //自动暂停其他视频
  listenVideo() {
    const v: any = this.$refs.PCvideo;
    if (!v) return;
    v.forEach((video: any) => {
      video.addEventListener("play", (d: any) => {
        v.forEach((item: any) => {
          if (d?.currentTarget?.id !== item?.id) {
            item?.pause();
          }
        });
      });
    });
  }
  sendHeight() {
    const t = setInterval(() => {
      if (document.readyState === "complete") {
        window.parent.postMessage(
          { height: document.getElementById("mainBox")?.scrollHeight },
          "*"
        );
        clearInterval(t);
      }
    }, 500);
  }
  getBlankAnswer(q: any) {
    const list = q.blankQuestionConfig.answerList;
    let res = ``;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d.words}） `;
    });
    return res;
  }
  //打开简历 新版字段
  async showAttachment(url: string) {
    const androidPdf =
      /(Android)/i.test(navigator.userAgent) && url?.slice(-3) === "pdf";
    if (
      url?.slice(-4) === "docx" ||
      url?.slice(-3) === "doc" ||
      url?.slice(-4) === "pptx" ||
      androidPdf
    ) {
      await this.sendRequest("/aiExam/common/previewDocUrl", { url }).then(
        (res: any) => {
          url = res?.data?.url;
        }
      );
    }
    const h = window.outerHeight;
    const w = Math.max((window.innerWidth - 840) / 2, 540);
    const left =
      (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
    if (this.isMobile()) {
      document.location.href = url;
    } else {
      window.open(
        url,
        "_blank",
        `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
      );
    }
  }
  //打开简历 老版配置
  showAttachmentOld(url?: string) {
    const h = window.outerHeight;
    const w = Math.max((window.innerWidth - 840) / 2, 540);
    const left =
      (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
    window.open(
      this.candidate.attachmentUrl,
      "_blank",
      `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
    );
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          resolve(resp.data);
        } else {
          reject(resp.data.message);
        }
      });
    }).catch(e => {
      console.log(e);
    });
  }

  // 微信版本，复制报告链接
  copyUrl() {
    const previewUrl = window.location.href;
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = previewUrl;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);

    this.showCopyToast = true;
    this.toastCountDown();
  }
  toastCountDown() {
    const TIME_COUNT = 2;
    if (!this.timer) {
      this.count = TIME_COUNT;
      this.timer = setInterval(() => {
        if (this.count > 1 && this.count <= TIME_COUNT) {
          //限制倒计时区间
          this.count--;
        } else {
          clearInterval(this.timer); //删除定时器
          this.timer = 0;
          this.showCopyToast = false;
        }
      }, 1000);
    }
  }
  //牛人 复制链接
  copyLink(type: string) {
    //创建input标签
    const input = document.createElement("input");
    //取路径参数
    const URL = document.URL;
    let param = URL.slice(URL.indexOf("?"));
    //加密的 去掉sid
    if (type !== "visible") {
      const i = param.indexOf("sid");
      if (i !== -1) {
        param = param.slice(0, i - 1);
      }
    }
    //复制值
    input.value = this.candidate.shareHost + param;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    //关闭弹窗
    if (this.isPc) {
      this.$message.success("复制成功");
    } else {
      (document.getElementsByClassName("pass")[0] as HTMLElement).click();
    }
  }
  setScroll() {
    //滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.handleScroll();
      });
    });
    this.handleScroll();
  }
  //判断某个原生DOM元素是否不在屏幕可见区内
  isElementNotInViewport(el: HTMLElement) {
    const rect = el?.getBoundingClientRect();
    return (
      rect?.top >=
        (window.innerHeight || document.documentElement.clientHeight) ||
      rect?.bottom <= 0
    );
  }
  // 滑动到底 固定底部
  handleScroll() {
    if (this.isElementNotInViewport(this.$refs.foot as HTMLElement)) {
      this.fixedFoot = true;
    } else {
      this.fixedFoot = false;
    }
  }
  setCompanyLink() {
    const company = this.all.exam.company;
    if (company.shortname) {
      document.title = company.shortname.substring(0, 6);
    }
    if (company.companyIcon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link") as HTMLLinkElement;
      }
      if (link) {
        link.rel = "icon";
        link.href = company.companyIcon;
        document.head.appendChild(link);
      }
    }
  }
  playAudioDesc(q: any) {
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach(function(audioElement: any) {
      audioElement.pause();
    });
    // 播放音频材料
    if (!this.audioElement) {
      this.audioElement = document.createElement("audio");
      document.body.appendChild(this.audioElement);
    } else {
      this.audioElement.pause();
    }
    this.audioElement.setAttribute("id", "audioDesc-" + q.questionId);
    this.audioElement.setAttribute("src", q.audioDescUrl);
    this.audioElement.play();
  }
  getAIComment(answer: any) {
    return answer.aiComment.replaceAll("\n", "<br/>");
  }
}
